module.exports = __webpack_public_path__ + "img/sold_house.376a947e.svg";